/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { map } from 'rxjs/operators';
import { Result } from '../../interfaces/helpers';
import { MetadataContainer } from '../container';

interface Relationship<T> {
  repository: any;
  expression?: { [name: string]: (object: T) => any };
  api?: (object: T) => any;
}

export function OneToMany<T>(configuration: Relationship<T>) {
  return function(target: Object, propertyKey: string) {
    let value: any;

    const getter = function(this: { [name: string]: any }) {
      const queryParams = {};
      let newApi = '';

      // creating query string to do the search
      if (configuration.expression) {
        const propertyNames = Object.keys(configuration.expression);

        propertyNames.forEach((property) => {
          queryParams[property] = configuration.expression[property](this as T);
        });
      }

      // overload api
      if (configuration.api) {
        newApi = configuration.api(this as T);
      }

      const repository = MetadataContainer.pool.getRepository(
        configuration.repository
      );

      const oldApi = repository.api;
      repository.api = `${repository.api}${newApi}`;

      value = repository.getAll(queryParams);
      // use this if you want to return only the items
      // .pipe(map((data: Result<any[]>) => data.items));
      repository.api = oldApi;

      return value;
    };

    const setter = function(newVal: any) {
      value = newVal;
    };

    Object.defineProperty(target, propertyKey, {
      get: getter,
      set: setter,
    });
  };
}
